import { pianoParser } from "../../../../../common/parameters";
import getKeyOffset from "./getKeyOffset";
import getScore from "./getScore";
import { parseDo } from "../../../Score/methods/changeDo";
import piano from "../../../../piano";
import player from "../../../../player";
import scrollToBar from "./scrollToBar";
import { INotationThis } from "./interfaces";
import { IBar } from "../../../../../common/types";
import { getAccidentals } from "../../../Score/score-display/utils";

export const deletePitch = function (this: INotationThis) {
    let { activeVoice } = this.state;
    const taskScore = this.state.taskScore!;
    let currentNote = this.state.currentNote!;
    let lastNote = {
        ...currentNote,
    };
    let bar = taskScore?.["bars" + (activeVoice || "")]?.[currentNote.bar] as IBar;
    if (bar && bar.notes[currentNote.note]) {
        let note = bar.notes[currentNote.note];
        if (note.p) {
            delete note.p;
            if (note.tie) {
                let nextNote = bar.notes[currentNote.note + 1];
                if (!nextNote) {
                    nextNote = (taskScore["bars" + (activeVoice || "")] as IBar[])[currentNote.bar + 1].notes[0];
                }
                delete nextNote.p;
            }
            this.setState({ taskScore, submitable: false });
            return;
        }
    }
    do {
        currentNote.note--;
        if (-1 === currentNote.note) {
            currentNote.bar--;
            bar = taskScore["bars" + (activeVoice || "")][currentNote.bar];
            if (!bar) {
                currentNote = lastNote;
                break;
            }
            currentNote.note = bar.notes.length - 1;
        }
    } while (bar && bar.notes.length && bar.notes[currentNote.note].r);
    if (bar) {
        delete bar.notes[currentNote.note].p;
    }
    // search for tie
    lastNote = {
        ...currentNote,
    };
    lastNote.note--;
    let isFirstNote = false;
    if (-1 === lastNote.note) {
        lastNote.bar--;
        if (taskScore["bars" + (activeVoice || "")][lastNote.bar]) {
            lastNote.note = taskScore["bars" + (activeVoice || "")][lastNote.bar].notes.length - 1;
        } else {
            isFirstNote = true;
        }
    }
    if (!isFirstNote) {
        let note = taskScore["bars" + (activeVoice || "")][lastNote.bar].notes[lastNote.note];
        if (note.tie) {
            delete note.p;
            currentNote = lastNote;
        }
    }
    scrollToBar(this.distribution, this.scoreRef, currentNote.bar);
    this.setState({
        currentNote,
        taskScore,
        submited: false,
        incorrectNotes: [],
        submitable: false,
    });
};

export const selectNote = function (this: INotationThis, bar: number, note: number, voice: number) {
    const { taskScore, playing } = this.state;
    const { task, plan } = this.props;
    if ((taskScore!["bars" + (voice || "")] as IBar[])[bar].notes[note].r) return;
    if ((task.type === "intervals" || task.type === "chords3") && !playing) {
        const score = getScore(plan, task)!;
        const accidentals = getAccidentals(score);
        const playingNote = (score["bars" + (voice || "")] as IBar[])[bar].notes[note].p!;
        const pitches = (Array.isArray(playingNote) ? playingNote : [playingNote]);
        const doPos = parseDo(accidentals[bar]);
        const pianoPitches = pitches.map(pitch => {
            return (
                60 +
                pianoParser[pitch.s] +
                (pitch.a || 0) +
                getKeyOffset(doPos.value + 6) +
                doPos.alt +
                ((pitch.o || 0) + (score["octave" + voice] || 0)) * 12
            );
        });
        pianoPitches.forEach(pitch => {
            piano.play(pitch, player.context.currentTime, 0.6);
        });
    }
    this.setState({
        currentNote: {
            bar,
            note,
        },
        activeVoice: voice,
        submited: false,
        incorrectNotes: [],
    });
};
